import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import authReducer from "./AuthSlice";
import commonReducer from "./CommonSlice";
import userReducer from "../views/modules/UserManagement/utils/slice";
import roleReducer from "../views/modules/RoleManagement/utils/slice";
import cmsPagesReducer from "../views/modules/Setting/Cms/utils/slice";
import landingPageReducer from "../views/modules/Setting/LandingPage/utils/slice";
import raceReducer from "../views/modules/RaceManagement/utils/slice";
import veteranStatusManagementReducer from "../views/modules/VeteranStatusManagement/utils/slice";
import vrTrainingLocationReducer from "../views/modules/VrTrainingLocation/utils/slice";
import interestDiscoveryReducer from "../views/modules/InterestDiscovery/utils/slice";
import testimonialReducer from "../views/modules/Testimonial/utils/slice";
import careerReducer from "../views/modules/Careers/utils/slice";
import chartReducer from "../views/modules/Dashboard/utils/slice";
import careerCategoriesReducer from "../views/modules/CareerCategories/utils/slice";
import certificationsReducer from "../views/modules/Certifications/utils/slice";
import occupationalGroupsReducer from "../views/modules/OccupationalGroups/utils/slice";
import skillCategoriesReducer from "../views/modules/SkillCategories/utils/slice";
import educationTrainingReducer from "../views/modules/EducationTraining/utils/slice";
import experienceReducer from "../views/modules/Experience/utils/slice";
import careerPathReducer from "../views/modules/CareerPath/utils/slice";
import skillPortraitReducer from "../views/modules/SkillPortrait/utils/slice";
import customerAccessReducer from "../views/modules/CustomerAccess/utils/slice";
import companyReducer from "../views/modules/Company/utils/slice";
import industryReducer from "../views/modules/Industry/utils/slice";
import AcronymReducer from "../views/modules/Acronyms/utils/slice";
import careerGroupReducer from "../views/modules/CareerGroup/utils/slice";
import importActivityReducer from "../views/modules/ImportActivity/utils/slice";

const reducer = {
  common: commonReducer,
  auth: authReducer,
  user: userReducer,
  role: roleReducer,
  cmsPages: cmsPagesReducer,
  landingPage: landingPageReducer,
  race: raceReducer,
  veteranStatus: veteranStatusManagementReducer,
  vrTrainingLocation: vrTrainingLocationReducer,
  interestDiscovery: interestDiscoveryReducer,
  skillPortrait: skillPortraitReducer,
  testimonial: testimonialReducer,
  career: careerReducer,
  chartjs: chartReducer,
  careerCategories: careerCategoriesReducer,
  certifications: certificationsReducer,
  occupationalGroups: occupationalGroupsReducer,
  skillCategories: skillCategoriesReducer,
  educationTraining: educationTrainingReducer,
  experience: experienceReducer,
  careerPath: careerPathReducer,
  customerAccess: customerAccessReducer,
  company: companyReducer,
  industry: industryReducer,
  acronyms: AcronymReducer,
  careerGroup: careerGroupReducer,
  importActivity: importActivityReducer,
};

const store = configureStore({
  reducer: reducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<any>
>;

export default store; // Export the store as the default export
